import { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";

const ProtectedRoute = () => {
    const navigate = useNavigate();
    const { authenticated, user } = useAuth();

    useEffect(() => {
        if (!user) return;

        // Only redirect if the user is on '/'
        if (window.location.pathname !== "/") return;

        // Redirect to the appropriate dashboard based on user role
        if (user.is_admin) {
            navigate("/admin", { replace: true });
        } else {
            navigate(`/organizations`, { replace: true });
        }
    }, [navigate, user]);

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
